import posthog from 'posthog-js';

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (initialized) return;
  if (import.meta.env.DEV) {
    console.info('[posthog] dev environment — analytics disabled');
    return;
  }
  if (!KEY) {
    console.warn('[posthog] VITE_POSTHOG_KEY not set — analytics disabled');
    return;
  }

  posthog.init(KEY, {
    api_host: HOST,
    // We call $pageview manually on route changes (see usePostHogPageviews)
    // because react-router doesn't trigger full page loads.
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only',
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true, email: false },
    },
    autocapture: true,
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.debug(false);
    },
  });

  initialized = true;
}

export { posthog };
